export default __webpack_public_path__ + "static/FoundersGrotesk-Semibold-fde11bbc6f62ae055ef481fd185b13ad.otf";